import React from "react";
import { Link } from "react-router-dom";
import Img from "../ui/Img";
import jem_logo from "../../assets/images/j.e.m-grey.png";
import { ReactComponent as AnchorFmIcon } from "../../assets/svg/anchor-fm.svg";
import { ReactComponent as InstagramIcon } from "../../assets/svg/instagram-grey.svg";
import { ReactComponent as FacebookIcon } from "../../assets/svg/facebook-grey.svg";
import { ReactComponent as WhatsappIcon } from "../../assets/svg/whatsapp-grey.svg";
import { ReactComponent as MailIcon } from "../../assets/svg/mail-grey.svg";
import { ReactComponent as CallIcon } from "../../assets/svg/call-grey.svg";

const Footer = () => {
  return (
    <footer className="bg-pale-blue p-4">
      <div className="wrapper text-grey grid grid-cols-2 md:flex gap-6 justify-between">
        {/* //? ______________________LOGO_____________________ */}
        <div className="flex gap-2 col-span-2 mt-1">
          <Link to="/">
            <Img src={jem_logo} width="45" alt="Jesus Empowerment Ministries" />
          </Link>
          <p className="font-bold leading-4 text-sm">
            Jesus <br />
            Empowerment <br />
            Ministries
          </p>
        </div>
        {/* //? ______________________CONNECT_____________________ */}
        <div className="">
          <h3 className="font-bold text-base mb-2">Connect</h3>
          <div className="grid grid-cols-3 gap-3 justify-center place-items-center max-w-[12rem]">
            <a
              href="https://www.instagram.com/evg_tina_chukwuka/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <InstagramIcon width={20} />
            </a>
            <a
              href="https://www.facebook.com/jesusempowermentministries"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FacebookIcon width={25} />
            </a>
            <a
              href="https://podcasters.spotify.com/pod/show/tina-chukwuka"
              target="_blank"
              rel="noopener noreferrer"
            >
              <AnchorFmIcon width={25} height={25} />
            </a>
            <a
              href="https://wa.link/yzyfkj"
              target="_blank"
              rel="noopener noreferrer"
            >
              <WhatsappIcon width={25} height={25} />
            </a>
            <a
              href="mailto:jesusempowermentministries@gmail.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <MailIcon width={24} height={24} />
            </a>
            <a
              href="tel:+2348140302909"
              target="_blank"
              rel="noopener noreferrer"
            >
              <CallIcon width={25} height={25} />
            </a>
          </div>
        </div>
        {/* //? ______________________LOCATION_____________________ */}
        <div className="">
          <h3 className="font-bold text-base mb-2">Location</h3>
          <div className="w-[11rem]">
            <a
              href="https://www.google.com/maps/place/Jesus+Empowerment+Ministries/@6.516811,3.315295,17z/data=!3m1!4b1!4m14!1m7!4m6!1m4!2m2!1d3.3086788!2d6.5141937!4e1!1m0!3m5!1s0x103b8f98e18e5d6f:0xbf02e22f1c417b5!8m2!3d6.516811!4d3.3178699!16s%2Fg%2F11rtf6tw5f?entry=ttu"
              target="_blank"
              rel="noopener noreferrer"
            >
              15 Olufemi kolawole street Okota Lagos, Nigeria
            </a>
          </div>
        </div>
        {/* //? ______________________OUR WORK_____________________ */}
        <div className="">
          <h3 className="font-bold text-base mb-2">Our Work</h3>
          <div className="flex flex-col gap-2">
            <Link to="/gallery">Gallery</Link>
            <Link to="/ministry">Ministry</Link>
          </div>
        </div>
        {/* //? ______________________SUPPORT_____________________ */}
        <div className="">
          <h3 className="font-bold text-base mb-2">Support</h3>
          <div className="flex flex-col gap-2">
            <Link to="/">Donate</Link>
            <Link to="/contact-us">Contact Us</Link>
          </div>
        </div>
        {/* //? ______________________COPYRIGHT_____________________ */}
        <div className="col-span-2 md:w-[11rem]">
          <p>Copyright © 2023 Jesus Empowerment Ministries</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
